import { GetMenuAggregate } from "@aitisal/contracts/restaurant/menu";
import { getMenuAggregate } from "@aitisal/sdk/restaurant/menu";
import { getSalesChannelMenuAggregate } from "@aitisal/sdk/restaurant/sales-channel";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useSession } from "../stores/sessionStore";
import { useBrandingConfig } from "../utils/brandingConfig";

export function useMenuAggregate() {
  const { pointOfOrder, restaurantId }: any = useSession();
  const { brandId } = useBrandingConfig();

  const salesChannelId = pointOfOrder?.salesChannelId;

  const isSalesChannel = Boolean(salesChannelId);

  return useQuery<GetMenuAggregate>({
    queryKey: [
      "menus-overview",
      brandId,
      salesChannelId ?? null,
      restaurantId || null,
    ],
    queryFn: async () => {
      if (salesChannelId) {
        return (
          await getSalesChannelMenuAggregate(brandId, salesChannelId, restaurantId)
        ).data;
      }
      return (await getMenuAggregate(brandId)).data;
    },
    enabled: Boolean(brandId),
    ...(isSalesChannel
      ? {}
      : { staleTime: Infinity, refetchOnWindowFocus: false }),
    placeholderData: keepPreviousData,
  });
}